import React, {useEffect, useState} from "react";
import { useEventContext } from "../../context/EventContext";
import { useLocaleContext } from "../../context/LocaleContext";
import { useWidgetContext } from "../../context/WidgetContextProvider";
import { getPrivacyOffers, getRegistrationFields } from "../../utils";
import { TYPE_HYBRID } from "../../constants/common";
import Theme from "../EventPage/Theme";
import AuthenticationBlock from "../../blocks/AuthenticationBlock";
import { ParticipationTypeSelectBlock } from "../../blocks/ParticipationTypeSelectBlock";
import { services } from "@offline/components/SignIn/SocialLogin";
import InfoAuthentication from "../../components/Authentication/InfoAuthentication";
import Icons from "../../components/Icons";

import './style.scss';

export default ({ onChoiceParticipationType, force, preview }) => {

    const {event} = useEventContext();
    const $locale = useLocaleContext();
    const { isWidget } = useWidgetContext();    

    const {moduleAuth, moduleTheme} = event;
    const {backgroundColor, textColor} = moduleTheme;

    const [previewComponent, setPreviewComponent] = useState(preview ? (event.participationType !== TYPE_HYBRID ? 'email' : 'partTypeSelect') : null)
    const [moduleSettings, setModuleSettings] = useState(event.moduleSettings);
    const [registrationFields, setRegistrationFields] = useState(event.registrationFields);

    const {backgroundImage, hideInfoBlock, changeSubstrate} = moduleSettings;
    const authBlockBackgroundColor = `#${(backgroundImage && !changeSubstrate) ? `${backgroundColor}cc` : `${textColor}0d`}`;
    const isParticipationTypeSelectVisible = !moduleAuth.require && event.participationType === TYPE_HYBRID && (!preview || previewComponent === 'partTypeSelect');
    const customDescription = $locale.getProperty(moduleAuth, 'customDescription') || $locale.getProperty(moduleSettings, 'loginSubtitle');
    const renderInfo = preview ? (moduleAuth.require && !hideInfoBlock) : (!hideInfoBlock && !force);
    const renderAuthBlock = preview ? previewComponent !== 'partTypeSelect' : (force || moduleAuth.require);

    useEffect(() => {
        const messageHandler = (e) => {
            try {
                let data = typeof e.data === 'string' ? JSON.parse(e.data) : e.data;
                if (!data || data.page !== 'auth') {
                    return;
                }

                if (data.component) {
                    setPreviewComponent(data.component);
                }

                if (data.settings) {
                    setModuleSettings(data.settings)
                }

                if (data.registrationFields) {
                    setRegistrationFields(data.registrationFields)
                }

            } catch (error) {
                console.error(error);
            }
        };

        if (preview) {
            window.addEventListener('message', messageHandler, false);
        }

        return () => {
            window.removeEventListener('message', messageHandler);
        }
    }, [preview]);

    return (
        <section>
            <Theme />
            <div
                className={`authentication ${isWidget ? 'widget' : ''} login-page`}
                style={{backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none'}}
            >
                <div
                    style={{
                        backgroundColor: authBlockBackgroundColor,
                        maxWidth: !renderInfo ? ((moduleAuth.require || !isParticipationTypeSelectVisible) ? '800px' : '464px') : '1080px',
                    }}
                    className="authentication__content"
                >
                    <div className={`authentication__block-auth ${renderInfo ? 'authentication__block-auth--two-column' : ''}`}>
                        {
                            renderInfo &&
                            <InfoAuthentication
                                $locale={$locale}
                                posterImage={moduleSettings.posterImage ?? ''}
                                eventName={$locale.getProperty(event, 'name')}
                                eventTitle={$locale.getProperty(moduleSettings, 'eventTitle')}
                                hideEventTitle={moduleSettings.hideEventTitle}
                                eventSubtitle={$locale.getProperty(moduleSettings, 'eventSubtitle')}
                                hideEventSubtitle={moduleSettings.hideEventSubtitle}
                                date={$locale.getProperty(moduleSettings, 'date')}
                                eventTimeStart={event.timeStart}
                                eventTimeStop={event.timeStop}
                                hideDate={moduleSettings.hideDate}
                                hideFormat={moduleSettings.hideFormat}
                                eventParticipationType={event.participationType || 'hybrid'}
                            />
                        }
                        {
                            renderAuthBlock &&
                            <AuthenticationBlock
                                preview={preview}
                                previewComponent={previewComponent}
                                eventKey={event.eventKey}
                                eventName={$locale.getProperty(event, 'name')}
                                timeStart={event.timeStart}
                                customDescription={customDescription}
                                eventPremoderation={moduleAuth.accessPreModeration}
                                participationType={event.participationType}
                                $locale={$locale}
                                loginWithEmailEnabled={moduleAuth.email}
                                loginWithNameEnabled={moduleAuth.guest}
                                loginWithPhoneEnabled={moduleAuth.phone}
                                externalServices={services.filter((name) => moduleAuth[name])}
                                ssoIconUrl={moduleAuth.ssoIconUrl}
                                registrationFields={getRegistrationFields({...event, registrationFields}, $locale.getProperty)}
                                privacyOffer={getPrivacyOffers(event, $locale)}
                                moduleSettings={moduleSettings}
                                moduleAuth={event.moduleAuth}
                                authRequired={moduleAuth.require}
                                hideInfoBlock={hideInfoBlock}
                                corporateMail={moduleAuth.corporateMail ?? false}
                                participationFormatLabels={moduleAuth.participationFormatLabels ?? []}
                                registrationType={moduleAuth.registrationType ?? 'hybrid'}
                            />
                        }
                        {
                            isParticipationTypeSelectVisible &&
                            <ParticipationTypeSelectBlock
                                $locale={$locale}
                                eventName={$locale.getProperty(event, 'name')}
                                timeStart={event.timeStart}
                                hideSubtitle={moduleSettings.hideParticipationTypeSubtitle ?? false}
                                subtitle={$locale.getProperty(moduleSettings, 'participationTypeSubtitle') || ''}
                                hideInfoBlock={hideInfoBlock}
                                participationTypeLabels={moduleAuth.participationFormatLabels ?? null}
                                onSelect={onChoiceParticipationType}
                            />
                        }
                    </div>
                    <footer className="auth-footer">
                        {event.moduleBranding.showComdiBanner && (
                            <a href="https://www.comdi.com/?utm_source=platform&utm_medium=registration_form&utm_campaign=users" target="_blank">
                                <Icons name="comdi_logo" />
                            </a>
                        )}
                    </footer>
                </div>
            </div>
        </section>
    );
}
